import portalApi from './axios/portalAxios';
import parentApi from './axios/studentAxios';

export const checkTeacherProfile = () => {
  return portalApi.get('/teacher-profile/check');
};

export const getMyTeacherProfile = () => {
  return portalApi.get('/teachers/me/profile');
};

export const createTeacherProfile = (data) => {
  return portalApi.post('/teacher-profile', data);
};

export const updateTeacherProfile = (id, data) => {
  if (data instanceof FormData) {
    data.append('_method', 'PUT');
    return portalApi.post(`/teachers/${id}`, data);
  }
  return portalApi.put(`/teachers/${id}`, data);
};

export const deleteTeacherProfile = (id) => {
  return portalApi.delete(`/teachers/${id}`);
};

export const getTeacherById = (id) => {
  return portalApi.get(`/teachers/${id}`);
};

export const getTeacherByUserId = (userId) => {
  return portalApi.get(`/teachers/user/${userId}`);
};

export const submitTeacherReview = (teacherId, data) => {
  return parentApi.post(`/teachers/${teacherId}/review`, data);
};

export const getPaginatedTeachers = (page = 1, perPage = 6, filters = {}) => {
  const params = {
    page,
    per_page: perPage,
  };

  if (filters.search) params.search = filters.search;
  if (filters.subject) params.subject = filters.subject;
  if (filters.status !== undefined && filters.status !== '') params.status = filters.status;

  return portalApi.get('/teachers', { params });
};
